import { render, staticRenderFns } from "./PetitionSmsMessages.vue?vue&type=template&id=1fa7dc59&"
import script from "./PetitionSmsMessages.vue?vue&type=script&lang=js&"
export * from "./PetitionSmsMessages.vue?vue&type=script&lang=js&"
import style0 from "./PetitionSmsMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports